import React from 'react';
import useStyles from './styles';
import clsx from 'clsx';
import { Grid } from '@material-ui/core'

const ProgressBarHeader = (props) => {
    const { levelText = 0, isExtraMax = false } = props;
    const classes = useStyles(props)

    return (
        <>
            {
                isExtraMax ?
                    <Grid item xs={12} className={classes.root}>
                        <div className={clsx(classes.fullWidth)}>
                            <div className={clsx(classes.textLevelCurrent)}>{`EXTRA MAX`}</div>
                            <div className={clsx(classes.levelWidth)}></div>
                        </div>
                    </Grid>
                    :
                    <Grid item xs={12} className={classes.root}>
                        <div className={clsx(classes.fullWidth)}>
                            <div className={clsx(classes.textLevelCurrent)}>{`LV ${levelText}/5`}</div>
                            <div className={clsx(classes.levelWidth)}></div>
                            <div className={clsx(classes.currentLevel, classes.textLevel)}>{levelText}</div>
                            <div className={clsx(classes.currentLevel, classes.bgTextLevel)}></div>
                            <div className={clsx(classes.currentLevel, classes.borderTextLevel)}></div>

                            <div className={clsx(classes.maxLevel, classes.textLevel, classes.textMaxLevel)}>5</div>
                            <div className={clsx(classes.maxLevel, classes.borderTextLevel)}></div>
                        </div>
                    </Grid>
            }
        </>
    )
}

export default ProgressBarHeader;

